import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Device } from '../../../model/device';
import { ApiService } from '../../../service/api.service';
import { Configuration } from '../../../model/configuration';
import { TranslateService } from '@ngx-translate/core';
import { MessageDialogComponent } from '../../dialogs/message-dialog/message-dialog.component';

@Component({
  selector: 'app-device-detail',
  templateUrl: './device-detail.component.html',
  styleUrls: ['./device-detail.component.scss']
})
export class DeviceDetailPopupComponent implements OnInit {
  updating = false;
  device: Device;
  configuration: Configuration;
  displayedColumns = ['type', 'lastUpdate', 'lastRead', 'newValue'];
  warningMessage: string = null;
  infoMessage: string = null;

  constructor(
    private dialogRef: MatDialogRef<DeviceDetailPopupComponent>,
    private dialog: MatDialog,
    private apiService: ApiService,
    private translationService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: { device: Device },
  ) {
    this.device = this.data.device;
  }

  public ngOnInit() {
    this.updating = false;
    this.apiService.configuration(this.device.id)
      .subscribe(configuration => {
        if (configuration != null) {
          configuration = configuration as Configuration;

          configuration.timezone = localStorage.getItem('brio-timezone');
          if (!configuration.timezone) {
            configuration.timezone = null;
          }
          if (configuration.configStatus === 'target') {
            this.infoMessage = this.translationService.instant('DEVICE_DETAIL.CONFIGURATION_IS_PENDING');
          } else {
            this.infoMessage = null;
          }

          configuration.currentDate.defaultValue =
            Math.floor((configuration.currentDate.lastUpdateDate.getTime() - configuration.currentDate.lastValue) / 1000);
            // Computes the default dates which will be proposed for edition
          this.computeDefaultDates(configuration);

          this.configuration = configuration;
        } else {
          // No configuration available for the device
          this.dialogRef.close();
          this.dialog.open(MessageDialogComponent, {
            width: null,
            height: null,
            data: {
              Content: this.translationService.instant('DEVICE_DETAIL.NO_CONFIGURATION_AVAILABLE')
            }
          });
        }
      });
  }

  public onTimezoneChange() {
    localStorage.setItem('brio-timezone', this.configuration.timezone);
    this.computeDefaultDates(this.configuration);
  }

  public onCurrentDateChange(val) {
    if (val < -86400 && this.configuration.currentDate.edit === true) {
      this.configuration.nextRecordDate.edit = true;
      this.configuration.nextSendDate.edit = true;
      this.configuration.nextDiagnosisDate.edit = true;

      this.warningMessage = this.translationService.instant('DEVICE_DETAIL.BIG_CURRENT_DATE_OFFSET');
    } else {
      this.warningMessage = null;
    }
  }

  public close() {
    this.dialogRef.close();
  }

  public update() {
    this.updating = true;

    console.log(this.configuration.configurationUpdatePayload);

    this.apiService.configuration(this.device.id, this.configuration.configurationUpdatePayload)
      .subscribe(_ => {
        this.dialogRef.close({ refresh: true });
      });
  }

  private computeDefaultDates(configuration: Configuration) {
    if (configuration.timezone) {

      const now = new Date();

      let timeShift = 0;
      let dayOfWeek = 0;
      switch (configuration.timezone) {
        case 'europe':
          timeShift = 2;
          dayOfWeek = 1;
          break;
        case 'nam':
          timeShift = 8;
          dayOfWeek = 1;
          break;
        case 'usa':
          timeShift = 9;
          dayOfWeek = 1;
          break;
        case 'asia':
          timeShift = 22;
          dayOfWeek = 0;
          break;
        case 'pacific':
          timeShift = 16;
          dayOfWeek = 0;
          break;
        default:
          return;
      }

      const refDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), timeShift, 0, 0));

      configuration.nextRecordDate.defaultValue = (_ => {
        const date = new Date(refDate);
        date.setDate(date.getDate() + 1);
        return date;
      })();
      configuration.nextSendDate.defaultValue = (_ => {
        const date = new Date(refDate);
        date.setDate(date.getDate() + 2);
        return date;
      })();
      configuration.nextDiagnosisDate.defaultValue = (_ => {
        const date = new Date(refDate);
        date.setDate(date.getDate() + (dayOfWeek + 7 - date.getDay() % 7));
        return date;
      })();
    }
  }
}
